import type { WorkPhase } from '@myapp/contract'

export type PrimaryWorkAction = 'start-travel' | 'start' | 'complete' | 'end-departure'

export interface WorkActionState {
  isCompleted: boolean
  /** For appointments always true — they cannot exist unscheduled. */
  isScheduled: boolean
  isToday: boolean
  /** From `deriveWorkPhase(schedule)` — null = nothing started yet. */
  phase: WorkPhase | null
  plannedTravelMinutes: number
}

/**
 * The one primary-button rule both worker pages share, phase-driven since the start/stop v2
 * flow: with a planned Anfahrt the day starts with "Anfahrt starten" (strict sequence — the
 * backend enforces it too); without one it starts with "Arbeit starten" directly. An open
 * phase keeps its next action available past midnight; a fresh start is day-gated.
 *
 * ABFAHRT deliberately ignores `isCompleted`: completing flips the business status while the
 * departure is still running, and "Abfahrt beenden" must survive that.
 */
export function getPrimaryWorkAction(state: WorkActionState): PrimaryWorkAction | null {
  if (!state.isScheduled) return null

  switch (state.phase) {
    case 'ANFAHRT':
      return 'start'
    case 'ARBEIT':
      return 'complete'
    case 'ABFAHRT':
      return 'end-departure'
    case 'DONE':
      return null
    default:
      if (state.isCompleted || !state.isToday) return null
      return state.plannedTravelMinutes > 0 ? 'start-travel' : 'start'
  }
}
